import { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Dialog, makeStyles, Divider, withStyles, Button, Theme, createStyles, TextField } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { useDispatch, useSelector } from "react-redux";
import { addWebWidgetParticipantsBysessionCode } from "../../../store/actions/participant/experience";
import CustomSnackBar from '../../pages/creator/experienceManager/participantsDashboard/component/CustomSnackBar';
import {addLogToAws} from '../../../config/awslog';

const styles = (theme: Theme) =>
	createStyles({
		root: {
			margin: 0,
			padding: theme.spacing(2),
			paddingTop: 26
		},
		closeButton: {
			position: 'absolute',
			right: theme.spacing(1),
			background: 'transparent!important'
		},
		header: {
			color: '#212D40',
			fontFamily: 'Spartan-bold',
			fontSize: 24,
			paddingLeft: 17,
			paddingBottom: 7,
			display: 'flex',
			alignItems: 'center'
		}
	});

const useStyles = makeStyles(() => ({
	root: {},
	paper: {
		borderRadius: '24px!important'
	},
	createBtn: {
		width: 91,
		height: 37,
		borderRadius: 6,
		background: '#0179EE',
		color: '#FFFFFF',
		textTransform: 'none',
		fontSize: 14,
		fontFamily: 'roboto-regular',
		'&:hover': {
			background: '#0f9fef'
		},
	},
	cancelBtn: {
		width: 91,
		height: 37,
		borderRadius: 6,
		background: '#F0F0F0',
		color: '#697683',
		textTransform: 'none',
		fontSize: 14,
		fontFamily: 'roboto-regular',
		'&:hover': {
			background: '#e0e0e0',
		},
	},
	textField: {
		"& .MuiOutlinedInput-inputMarginDense": {
			margin: "0!important",
			border: '1px solid #697683',
			padding: 4,
			borderRadius: 3,
			paddingLeft: 6,
			fontSize: 14,
			color: '#717E8B',
		}
	},
	label: {
		"&$focusedLabel": {
			fontSize: 12,
			fontFamily: 'roboto-bold',
			color: "#606B76"
		},
		"&$erroredLabel": {
			color: "#707070"
		}
	},
	focusedLabel: {},
	erroredLabel: {},
	underline: {
		fontSize: 14,
		fontFamily: 'roboto-regular',
		color: '#697683',
		"&$error:after": {
			borderBottomColor: "#017AEF"
		},
		"&:after": {
			borderBottom: `3px solid #017AEF`
		}
	},
	error: {},
	description: {
		fontSize: 14,
		fontFamily: 'roboto-regular',
		color: '#697683'
	},
	input: {
		marginTop: 50
	}
}));

const DialogTitle = withStyles(styles)((props: any) => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<div className={classes.header}>
				{children}
				{onClose ? (
					<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
						<img src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'} />
					</IconButton>
				) : null}
			</div>
		</MuiDialogTitle>
	);
});

BleSessionCodeModal.propTypes = {
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
	selectedIndex: PropTypes.number,
	selectedOneDevice: PropTypes.any,
	bleDevice: PropTypes.any,
	modalSession_code:PropTypes.any,
	intervalSessioncheck: PropTypes.func
};
BleSessionCodeModal.defaultProps = {
	onClose: () => {
	},
	intervalSessioncheck: () => {
	}
};

function BleSessionCodeModal({ open, onClose, selectedOneDevice, intervalSessioncheck, selectedIndex,modalSession_code, bleDevice, ...rest }: any) {
	const classes = useStyles();
	const dispatch = useDispatch();
	const apolloClient = useSelector((state: any) => state.apolloClient);
	const [snackAlertType, setSnackAlertType] = useState('');
	const [snackAlertMsg, handleSnackMsg] = useState('');
	const [isShownSnackAlert, setShownSnackAlert] = useState(false);
	const [SessionCode, setSessionCode] = useState(modalSession_code);
	function hideSnackAlert() {
		setShownSnackAlert(false);
		handleSnackMsg('')
		onClose()
	}
	const onAddSession = async () => {
		if (validateSeession_code(SessionCode)) {
			const request = {
				session_code: SessionCode,
				identifier: selectedOneDevice.deviceIdentifier,
				temp_email: selectedOneDevice.temp_email,
				deviceId: selectedOneDevice.id
			};
			let errorMessage = "Problem occured while add participant"
			await dispatch(addWebWidgetParticipantsBysessionCode(apolloClient.client, request, (response: any) => {
				if (response) {
					if (response.status === true) {
						addLogToAws({ category:'success', method:'addWebWidgetParticipantsBysessionCode', message:'using modal add WebWidgetParticipants By sessionCode', data:{response}});
						bleDevice.filter((device: any) => device.id == response.data.device_id).map((bleElement: any) => {
							if (!!bleElement.session && bleElement.session.length > 0) {
								if (bleElement.session.find((obj: any) => obj.session_code !== response.data.session_code)) {
									bleElement.session.push({ session_code: response.data.session_code, session_type: response.data.session_type, session_title: response.data.session_title, session_status: response.data.session_status })
								}
							} else {
								intervalSessioncheck()
								Object.assign(bleElement, {
									session: [{ session_code: response.data.session_code, session_type: response.data.session_type, session_title: response.data.session_title, session_status: response.data.session_status }]
								})
							}
						}
						)
						const successMessage = "sucessfully add participant"
						setSnackAlertType('success')
						handleSnackMsg(successMessage)
						setShownSnackAlert(true);

					} else {
						setSnackAlertType('error')
						if (response.message) {
							addLogToAws({ category:'error', method:'addWebWidgetParticipantsBysessionCode', message:'using modal add WebWidgetParticipants By sessionCode', data:{response}});
							if (response.message == "Request failed with status code 404") {
								errorMessage = "Invalid session code provided, Please add valid session code."
							} else {
								errorMessage = response.message
							}
						}
						handleSnackMsg(errorMessage)
						setShownSnackAlert(true);
					}
				} else {
					setSnackAlertType('error')
					handleSnackMsg(errorMessage)
					setShownSnackAlert(true);
				}
			}));
		}
	};

	const onChangeSessionCode = (event: any) => {
		setSessionCode(event.target.value);
	};
	const validateSeession_code = (name: string) => {
		return name&&name.length > 1
	};
	return (
		<Dialog
			disableEscapeKeyDown
			fullWidth={true}
			maxWidth={'sm'}
			onClose={onClose}
			open={open}
			classes={{
				root: classes.root,
				paper: classes.paper
			}}
		>
			<div {...rest} >
				<DialogTitle onClose={onClose}>
					{selectedIndex >= 0 ? 'Rename' : 'Add Session'}
				</DialogTitle>
				<Divider />
				<Box m={4} pl={1} pr={1}>
					<TextField
						InputLabelProps={{
							classes: {
								root: classes.label,
								focused: classes.focusedLabel,
								error: classes.erroredLabel
							},
						}}
						InputProps={{
							classes: {
								root: classes.underline,
								error: classes.error
							}
						}}
						value={SessionCode}
						fullWidth
						margin="normal"
						id="session_code"
						label="Session Code"
						name="session_code"
						onChange={onChangeSessionCode}
					/>
				</Box>
				<Box mt={6} mb={3} mr={4} display='flex' justifyContent='flex-end'>
					<Button onClick={onClose} className={classes.cancelBtn}>
						Cancel
					</Button>
					&nbsp;&nbsp;&nbsp;
					<Button
						onClick={() => onAddSession()}
						className={classes.createBtn}
						disabled={!validateSeession_code(SessionCode)}
						style={!validateSeession_code(SessionCode) ? { backgroundColor: "#F0F0F0" } : {}}
					>{'Add'}
					</Button>
				</Box>
			</div>
			<CustomSnackBar type={snackAlertType} message={snackAlertMsg} open={isShownSnackAlert} onClose={hideSnackAlert} />
		</Dialog>
	);
}
export default BleSessionCodeModal;
